import { resourceTypes } from '../provisionQualitySinglePage/provisionQualitySingle.constants';

export default {
  resourceType: resourceTypes.business,
  businessCode: null,
  businessCodes: [],
  provisionQualityLoading: false,
  provisionQuality: {
    readyToTax: 0,
    calcErrorCount: 0,
    successComplete: 0,
    successPercent: 0,
    trialBalanceNotReceivedCount: 0,
    validErrorCount: 0,
  },
  lastRunDate: '',
  lastFetch: '',

  allProvisions: [],
  processedSuccessfully: [],
  trialBalancesNotReceived: [],
  trialBalancesWithErrors: [],
  calculationsWithErrors: [],
  otherErrors: [],
  journals: [],
  localJournals: [],
};
